/**
 * This file is part of Zoosh.
 *
 * Copyright (c) 2012-2020, Shoop Commerce Ltd. All rights reserved.
 *
 * This source code is licensed under the OSL-3.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function () {
    const bar = document.querySelector(".gdpr-consent-warn-bar");
    const prefs = document.querySelector(".gdpr-consent-preferences");
    if (!bar || !prefs) return;

    // Windows Phone layout tweak
    if (/Windows Phone/i.test(navigator.userAgent)) {
        const content = bar.querySelector(".gdpr-consent-warn-content");
        if (content) content.classList.add("windows-phone");
    }

    // Open preferences panel
    const prefsBtn = document.getElementById("privacy-preferences-btn");
    if (prefsBtn) {
        prefsBtn.addEventListener("click", function (e) {
            e.preventDefault();
            prefs.classList.add("visible");
            document.body.classList.add("body-noscroll");
        });
    }

    // Close preferences panel
    const closeBtn = prefs.querySelector(".btn-close");
    if (closeBtn) {
        closeBtn.addEventListener("click", function () {
            prefs.classList.remove("visible");
            document.body.classList.remove("body-noscroll");
        });
    }

    // Consent option panel switching
    prefs.addEventListener("click", function (e) {
        const item = e.target.closest(".consent-option-item");
        if (!item) return;
        document.querySelectorAll(".gdpr-consent-preference-panel").forEach(function (p) {
            p.classList.remove("active");
        });
        document.querySelectorAll(".consent-option-item").forEach(function (i) {
            i.classList.remove("active");
        });
        item.classList.add("active");
        var target = item.dataset.target;
        if (target) {
            var panel = document.getElementById("consent_" + target);
            if (panel) panel.classList.add("active");
        }
    });

    // Save consent (used by both "I Understand" and "Save preferences")
    function saveConsent() {
        bar.style.display = "none";
        prefs.style.display = "none";

        var form = document.getElementById("consent-form");
        if (!form) return;

        var formData = new FormData(form);
        fetch(form.getAttribute("action"), {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "X-CSRFToken": formData.get("csrfmiddlewaretoken") || "",
            },
            body: new URLSearchParams(formData),
        }).then(function (response) {
            if (response.ok) {
                bar.remove();
                prefs.remove();
                document.body.classList.remove("body-noscroll");
            } else {
                throw new Error("Save failed");
            }
        }).catch(function () {
            bar.style.display = "";
            prefs.style.display = "";
            alert(typeof gettext === "function"
                ? gettext("Error! Saving the consent failed, please try again.")
                : "Error! Saving the consent failed, please try again.");
        });
    }

    var saveBtn = document.getElementById("btn-save-preferences");
    if (saveBtn) saveBtn.addEventListener("click", saveConsent);

    var agreeBtn = document.getElementById("agree-btn");
    if (agreeBtn) agreeBtn.addEventListener("click", saveConsent);
})();
